var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHzAssistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 43.53a6 6 0 11-4-5.65V20.77l-21 9.58v28.18a6 6 0 11-4-5.65v-29.3l29-13.22v33.17z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/HZ_Assistance.9b354df8.svg";
export { SvgHzAssistance as ReactComponent };